import XmlParser from './XmlParser.js';

class Conexoes {
  constructor() {
    this.credenciaisFile = window.location.origin + '/credenciais.xml';
    this.baseUrl = null;
    this.xmlParser = new XmlParser();
  }

  async carregarCredenciais() {
    const response = await fetch(this.credenciaisFile);
    const xmlData = await response.text();
    this.baseUrl = this.xmlParser.Parse(xmlData, 'url_base');
  }

  async conecta(api, parametros = {}) {
    if (!this.baseUrl) {
      await this.carregarCredenciais();
    }

    const url = `${this.baseUrl}/${api}`;
    console.log('Tentando conectar a:', url);

    // Preparamos as opções básicas da requisição
    let fetchOptions = {
      method: 'POST',
    };

    // === NOVA LÓGICA DE BLINDAGEM ===
    // Se marcamos que é FormData (para upload de arquivos), passamos o body cru.
    // O próprio navegador se encarrega de criar o cabeçalho 'multipart/form-data' corretamente.
    if (parametros.isFormData === true) {
      fetchOptions.body = parametros.body; 
    } 
    // Comportamento PADRÃO MANTIDO: Se não for FormData, continua a transformar tudo em texto JSON.
    else {
      fetchOptions.body = JSON.stringify(parametros);
    }
    // =================================
   
    try {
      const response = await fetch(url, fetchOptions);

      // 1. Extraímos a resposta como TEXTO PURO antes de qualquer coisa
      const rawText = await response.text();
      
      // 2. Imprimimos no console (com cor laranja para destacar no F12)
      //console.log(`%c[RESPOSTA BRUTA - ${api}]:`, 'color: orange; font-weight: bold;', rawText);

      try {
        // 3. Agora tentamos converter o texto que já vimos para JSON
        const json = JSON.parse(rawText);
        console.log('Resposta recebida (JSON Válido):', json);
        return json;
      } catch (jsonError) {
        // Se quebrar aqui, você já vai ter visto o erro PHP no console.log acima!
        console.error('Erro ao parsear JSON. O servidor não devolveu um JSON válido.', jsonError);
        return null;
      }
    } catch (fetchError) {
      console.error('Erro de rede ou fetch:', fetchError);
      return null;
    }
  }
}

export default Conexoes;